import { useMutation } from "@tanstack/react-query";
import { updateAvailability } from "../services/update-availability";
import { useToast } from "@/hooks/use-toast";

export function useUpdateAvailability() {
  const { toast } = useToast();

  return useMutation({
    mutationFn: () => updateAvailability(),
    onSuccess: () => {
      toast({
        title: "Success",
        description: "Availability updated successfully",
      });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message || "Failed to update availability",
        variant: "destructive",
      });
    },
  });
} 